import { gql } from "@apollo/client";

export const GET_APPLICATION_BY_REFERENCE_ID = gql`
  query Query($employerReferenceId: String!) {
    applicationsByEmployerReferenceId(
      employerReferenceId: $employerReferenceId
    ) {
      id
      jobId
      applicantId
      dateApplied
      employerReferenceId
      resumeS3Key
      resumeS3Bucket
      coverLetterS3Key
      coverLetterS3Bucket
      status
      applicantInfo {
        emailAddress
        firstName
        lastName
      }
      jobPosting {
        id
        role
        description
        team
        location {
          city
          state
          zipCode
        }
      }
    }
  }
`;

export const GET_EMPLOYER = gql`
  query Query {
    employer {
      employerId
      userId
      employerName
      employerSize
      signUpDate
      userInfo {
        emailAddress
      }
      jobPostings {
        id
        role
        description
        team
        location {
          city
          state
          zipCode
        }
        fields {
          fieldId
          required
        }
      }
    }
  }
`;
